import { getSalesSpaceChannelIdsForGrouping } from 'gcs-common/slices/salesSpaceChannels/salesSpaceChannelsSelectors';
import { useSelector } from 'react-redux';
import SalesSpaceChannelListItem from '../SalesSpaceChannelListItem/SalesSpaceChannelListItem';
import styles from './styles.module.scss';

interface SalesSpaceChannelGroupingSectionProps {
  grouping: string;
}

/**
 * A section in the Sales Space List
 * containing all the sales space channels for a specific grouping
 */
const SalesSpaceChannelGroupingSection = (props: SalesSpaceChannelGroupingSectionProps) => {
  const { grouping } = props;
  const groupingChannelIds: string[] = useSelector(getSalesSpaceChannelIdsForGrouping(grouping));

  if (!groupingChannelIds) {
    return null;
  }

  return (
    <div key={grouping}>
      <div className={styles.channelListSectionHeader}>
        <div className={styles.groupingHeader}>{grouping}</div>
      </div>
      {groupingChannelIds.map((channelId) => (
        <SalesSpaceChannelListItem key={channelId} channelId={channelId} />
      ))}
    </div>
  );
};

export default SalesSpaceChannelGroupingSection;
